/**
 * rocketPaste handles C&P of content
 * It sanitises the content with the help of sanitizeHtml
 * => https://github.com/apostrophecms/sanitize-html
 *
 * it can be customised via froala config:
 * @example
 *     rocketPasteAllowedTags: Array<string>, // e.g.: ['h2', 'h3']
 *     rocketPasteExtendDefault: boolean,
 *
 * rocketPasteExtendDefault: true // tags will be added to the default, otherwise they replace the default
 *
 *
 */

(function (global, factory) {
    typeof exports === "object" && typeof module !== "undefined"
        ? factory(require("froala-editor"))
        : factory(global.FE);
})(this, (FE) => {
    const sanitizeHtml = require("sanitize-html");
    const rocketPasteExtendDefault = true;
    const rocketPasteDefaultTags = () => [
        "p",
        "br",
        "b",
        "strong",
        "h3",
        "h4",
        "h5",
        "h6",
        "ul",
        "ol",
        "li",
        "blockquote",
    ];

    const getHtmlFromCB = (clipboardContent) => {
        const txtArea = document.createElement("textarea");
        txtArea.innerHTML = clipboardContent;
        return txtArea.value;
    };

    /**
     * sanitize function. Uses 3rd party sanitizeHtml function combined with custom cleanup
     * @param txt
     * @param allowedTags
     */
    const sanitize = (txt, allowedTags) =>
        // we actually want to keep these kind of whitespaces, therefore replace with a regular
        sanitizeHtml(
            txt
                .replace(
                    // remove wrapper b tag copied when pasting from google docs
                    /<b style="font-weight:normal;" id="docs-internal-guid-[^>]*>(.*)<\/b>/g,
                    "$1"
                )
                .replace(
                    // convert span tags with font-weight:700 into strong
                    /<span[^>]*?style="[^"]*font-weight:\s?700[^>]*>(.*?)<\/span>/g,
                    "<strong>$1</strong>"
                )
                .replace(/<span>\u00A0<\/span>/g, " "),
            { allowedTags }
        )
            .replace(/&nbsp;/g, " ")
            .replace(/\u00A0/g, " ")
            .replace(/<p>(<br(.*?)>){0, 1}<\/p>/g, " ")
            .replace(/\n/g, " ")
            .replace(/\s+/g, " ") // replace multiple spaces with just one
            .replace(
                /([\w,.])<strong>(.*?)<\/strong>/g,
                "$1 <strong>$2</strong>"
            )
            .replace(/<\/strong>(\w)/g, "</strong> $1");

    const rocketPasteAllowedTags = rocketPasteDefaultTags();
    // Add an option for your plugin.
    FE.DEFAULTS = Object.assign(FE.DEFAULTS, {
        rocketPasteAllowedTags,
        rocketPasteExtendDefault,
    });

    FE.PLUGINS.rocketPaste = (editor) => ({
        _init: () => {
            let tags = rocketPasteDefaultTags();

            let allowTable = editor.opts.toolbarButtons.includes("insertTable");
            if (allowTable) {
                tags.push("table", "thead", "tbody", "th", "tr", "td");
            }

            const allowedTags = editor.opts.rocketPasteExtendDefault
                ? [...tags, ...(editor.opts.tags || [])]
                : editor.opts.tags;

            editor.events.on("paste.beforeCleanup", (clipboardContent) =>
                sanitize(getHtmlFromCB(clipboardContent), allowedTags)
            );

            // here we can actually mess with the markup. We need to do it AFTER cleanup, otherwise it will be cleaned
            // by froala
            // editor.events.on("paste.afterCleanup", (sanitizedContent) =>
            //
            // );
        },
    });
});
